import Button from '@/components/Button';
import Card from '@/components/Card';
import CourseCard from '@/components/CourseCard';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import { Course } from '@/graphql/generated/graphql';
import useIsMobile from '@/hooks/useIsMobile';
import { fetchCourseHome } from '@/services/learn/course.service';
import { joinWithCommaAnd } from '@/utils/array';
import { getAuthors } from '@/utils/learn';
import { PlayIcon } from '@heroicons/react/24/solid';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loading } from './loading';
import { useResponsiveImage } from '@/utils/useResponsiveImage';

export default function Learn() {
  const [course, setCourse] = useState<Course | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { isMobile } = useIsMobile();
  const { src, alt } = useResponsiveImage(course?.thumbnail);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const courseResult = await fetchCourseHome();
      setCourse(courseResult);
      setLoading(false);
    })();
  }, []);

  if (loading) return <Loading />;

  if (!course) return null;

  const cardProps = {
    title: course?.title || '',
    tags: [
      <DefaultContentTemplateTags
        key={course?.title}
        duration={course?.duration || ''}
        tags={['Course']}
        className="!mb-sh-15 !mt-0"
      />,
    ],
    description: course?.description || '',
    author: joinWithCommaAnd(getAuthors(course as Course)?.map((author) => author?.attributes?.name)),
    image: {
      url: src || '',
      alternativeText: alt || '',
    },
    button: (
      <Button
        theme="solid"
        onClick={() => navigate(`/learn/course/${course?.slug}`)}
        className="col-span-12 !mb-0 !mt-0">
        <PlayIcon className="inline-block h-4 w-4" />
        <span>Find out more</span>
      </Button>
    ),
  };

  const Component = isMobile ? Card : CourseCard;

  return <Component {...cardProps} key={course!.title!} />;
}
